import Common from '../../../../Common';

const Group = class extends Common {
	constructor(headers: ApiHeaders) {
		super(headers)
	}

	async browse(companyId: id, groupId: id) {
		return this.get(`/company/${companyId}/acl/group/${groupId}/users`)
	}

	async browseDepartment(companyId: id, groupId: id) {
		return this.get(`/company/${companyId}/acl/group/${groupId}/usersdepartment`)
	}
}

export default Group;
